<template>
  <div :class="['mt-card', large ? 'mt-card-lg' : '']">
    <slot />
  </div>
</template>

<script setup>
const props = defineProps({
  large: Boolean
});
</script>
